export default "__VITE_ASSET__wCgw5UHN__"